<template>
  <div>
    <div class="afdc-container-fluid afdc-find-filters">
      <p class="afdc-corridor-description-text">
        <span v-html="$sprintf($t('Use this tool to view alternative fuel corridors designated by the <a href=\'%s\'>Federal Highway Administration</a> and to measure the distance between stations that meet the'), 'https://www.fhwa.dot.gov/environment/alternative_fuel_corridors/')"></span>
        <span class='afdc-corridor-help-link' @click='toggleCorridorHelp()'>{{ $t('criteria for corridors')}}</span>.
        <span v-html="$sprintf($t('Explore more <a href=\'%s\'>resources for corridors</a>. Have a comment or concern with this tool? <a href=\'%s\'> Please contact us</a>.'), 'https://afdc.energy.gov/corridors', 'https://afdc.energy.gov/website-contact.html')"></span>
      </p>
      <form v-on:submit.prevent class="afdc-tab-content">
          <corridor-filters/>
      </form>
      <template v-if="$store.getters.getStationsError">
        <div class="afdc-stations-error">
          <p class="afdc-alert afdc-alert-warning"><em>{{ $store.getters.getStationsError }}</em></p>
        </div>
      </template>
    </div>
    <div class ="afdc-row afdc-no-gutters">
      <div v-if="showCorridorStations === true" class="afdc-col-md-5">
        <corridor-results/>
      </div>
      <div :class="mapWidthClass">
        <div v-if="$store.getters.getLoadingCorridorStations" class="afdc-large-spinner-container">
          <div class="afdc-large-spinner"></div>
        </div>
        <router-view v-if="$store.getters.isNavActiveTabCorridors"/>
        <map-stations v-if="$store.getters.isNavActiveTabCorridors"/>
      </div>
    </div>
  </div>
</template>

<script>
import MapStations from '@/components/MapStations.vue';
import CorridorResults from '@/components/CorridorResults.vue';
import CorridorFilters from '@/components/CorridorFilters.vue';

export default {
  components: {
    MapStations,
    CorridorResults,
    CorridorFilters,
  },

  computed: {
    isCorridorRoute() {
      if (this.$route.name === 'CorridorStations') {
        return true;
      } return false;
    },

    showCorridorStations() {
      return this.$store.getters.getFilterValueWithDefault('show_corridor_stations');
    },

    mapWidthClass() {
      if (this.showCorridorStations === true) {
        return 'afdc-col-sm-7';
      }
      return 'afdc-col-sm-12';
    },
  },

  methods: {
    toggleCorridorHelp() {
      const helpStatus = this.$store.getters.getCorridorPopup;
      if (this.$store.getters.isNavActiveTabCorridors) {
        if (helpStatus === true) {
          this.$store.commit('setCorridorPopup', false);
        } else {
          this.$store.commit('setCorridorPopup', true);
        }
      }
    },
  },
};
</script>

<style lang="scss">

.corridor-description-text {
   line-height: 17px;
}

.corridor-help-link {
  color: #337ab7;
  border-bottom: 1px dotted #337ab7;
  &:hover {
    cursor: pointer;
    color: #23527c;
    border-bottom: 1px dotted #23527c;
  }
}

</style>
